import { render, staticRenderFns } from "./NewExpense.vue?vue&type=template&id=29e2f538&scoped=true&"
import script from "./NewExpense.vue?vue&type=script&lang=js&"
export * from "./NewExpense.vue?vue&type=script&lang=js&"
import style0 from "./NewExpense.vue?vue&type=style&index=0&id=29e2f538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2f538",
  null
  
)

export default component.exports